import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileDoc.tsx
const IconFileDoc = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "currentColor",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#6b91f2",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm5.995 6.166q-.414 0-.756-.138a1.54 1.54 0 0 1-.582-.408 1.9 1.9 0 0 1-.372-.678 3 3 0 0 1-.132-.942q0-.534.132-.936.132-.408.372-.678.24-.276.582-.414t.756-.138.756.138.582.414q.24.27.372.678.132.402.132.936t-.132.942a1.9 1.9 0 0 1-.372.678q-.24.27-.582.408t-.756.138m0-.81q.414 0 .642-.27.234-.27.234-.774v-.624q0-.504-.234-.774-.228-.27-.642-.27t-.648.27q-.228.27-.228.774v.624q0 .504.228.774.234.27.648.27m-5.863-3.45h1.578q.414 0 .756.132t.582.396q.24.258.372.654.132.39.132.912t-.132.918a1.8 1.8 0 0 1-.372.654 1.54 1.54 0 0 1-.582.39q-.342.132-.756.132h-1.578zm1.578 3.378q.408 0 .642-.228t.234-.732v-.648q0-.504-.234-.732t-.642-.228h-.666v2.568zm7.813.75q.342.132.768.132.582 0 .96-.258.384-.264.618-.744l-.744-.432q-.096.258-.3.444-.198.18-.534.18-.402 0-.648-.258-.24-.264-.24-.762v-.672q0-.498.24-.756a.84.84 0 0 1 .648-.264q.342 0 .516.162.18.156.264.42l.786-.408q-.228-.51-.606-.744-.378-.24-.96-.24-.426 0-.768.144a1.54 1.54 0 0 0-.582.426 1.9 1.9 0 0 0-.372.69 3 3 0 0 0-.132.936q0 .534.132.936.132.396.372.666.24.264.582.402",
			clipRule: "evenodd"
		})
	]
});
var IconFileDoc_default = forwardRef(IconFileDoc);
//#endregion
export { IconFileDoc_default as default };
